import { cn } from '@wwe-portal/ui/lib/lib';

export const ProgressBar = ({
  percent,
  currentProgress,
  totalProgress,
  title,
  className,
}: {
  title: string;
  percent: number;
  currentProgress: number;
  totalProgress: number;
  className?: string;
}) => {
  const getPercentWidth = () => {
    if (!percent) return '8px';
    return `${percent}%`;
  };

  return (
    <div
      className={cn(
        'absolute bottom-0 right-0 top-0 w-full select-none py-5 pr-4 md:pr-10',
        className
      )}
      data-enabled
    >
      <div className="relative cursor-pointer py-4">
        <div className="rounded-1 absolute h-2 w-[100%] rounded bg-[#F9EEEE]" />
        <div
          className="relative h-[8px] rounded bg-gradient-to-r from-[#FC8154] via-[#FFA800] to-[#FFBB00]"
          style={{
            width: getPercentWidth(),
          }}
        >
          <div
            className={cn(
              'absolute right-[5px] top-[2px] h-1 w-1 rounded-full blur-[4px]',
              {
                'right-[2px]': !percent,
              }
            )}
            style={{
              boxShadow: '0 0 0 4px #FFBB00',
            }}
          />
          <div
            className={cn(
              'absolute right-[5px] top-[2px] h-[3px] w-[3px] rounded-full bg-white',
              {
                'right-[2px]': !percent,
              }
            )}
          />
        </div>
        <span className="drop-shadow-text-2 absolute -left-0 -top-2 line-clamp-1 max-w-[calc(100%-100px)] text-xs font-medium uppercase">
          {title}
        </span>
        <span className="absolute -right-0 -top-3">
          <span className="drop-shadow-text-2 text-sm font-medium">
            <span className="text-yellow800">{currentProgress}</span>/
            {totalProgress}
          </span>
        </span>
      </div>
    </div>
  );
};
